import { render, staticRenderFns } from "./construccionContainer.vue?vue&type=template&id=d55caae8&scoped=true&"
import script from "./construccionContainer.vue?vue&type=script&lang=js&"
export * from "./construccionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55caae8",
  null
  
)

export default component.exports